import { useEffect, useState } from "react";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const CustomerApproveDialog = ({ customer, onClose, onApprove }) => {
  const [creditDays, setCreditDays] = useState(0);
  const [mobileVerified, setMobileVerified] = useState(true);

  useEffect(() => {
    if (customer) {
      setCreditDays(customer.credit_days || 0);
      setMobileVerified(customer.mobile_verified ?? true);
    }
  }, [customer]);

  const submit = async () => {
    try {
      await onApprove(customer.id, { credit_days: parseInt(creditDays) || 0, mobile_verified: mobileVerified });
      toast.success(`${customer.name} approved — they can now log in.`);
      onClose();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <Dialog open={!!customer} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Approve {customer?.name}</DialogTitle>
          <DialogDescription>Set payment terms and confirm the customer's details.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="text-xs space-y-1 p-3 bg-gray-50 border border-gray-200">
            <div><strong>Mobile:</strong> {customer?.mobile}</div>
            <div><strong>Address:</strong> {customer?.address}</div>
            <div><strong>Pincode:</strong> {customer?.pincode || "—"}</div>
            <div><strong>GST:</strong> {customer?.is_gst ? customer?.gstin : "Non-GST"}</div>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-gray-600">Credit days (payment terms)</Label>
            <Input type="number" min={0} max={365} value={creditDays} onChange={(e) => setCreditDays(e.target.value)} className="rounded-sm mt-1" data-testid="approve-credit-days"/>
          </div>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={mobileVerified} onChange={(e) => setMobileVerified(e.target.checked)} data-testid="approve-mobile-verified"/>
            Mobile number verified
          </label>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose} className="rounded-sm">Cancel</Button>
            <Button onClick={submit} className="bg-[#0e5a32] hover:bg-[#0a4626] rounded-sm" data-testid="approve-submit">Approve customer</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
